import { html } from "lit-element";

export const logo = html`
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
    width="180px" height="180px" viewBox="0 0 30.238 30.238" style="enable-background:new 0 0 30.238 30.238;" xml:space="preserve">
    <g>
        <path d="M29.504,25.972l-6.718-6.719c-0.354-0.355-0.793-0.578-1.252-0.675c1.896-2.725,2.506-6.068,1.851-9.2l-2.74,2.688   c-0.059,2.182-0.909,4.347-2.57,6.008c-3.444,3.443-9.048,3.443-12.492,0c-3.444-3.444-3.444-9.048,0-12.492   c3.444-3.443,9.048-3.443,12.492,0c0.49,0.49,0.902,1.027,1.252,1.593l-6.343,6.222L7.856,8.484   C7.258,7.91,6.309,7.931,5.735,8.529C5.162,9.127,5.182,10.077,5.78,10.65l6.177,5.918c0.29,0.277,0.664,0.416,1.038,0.416   c0.379,0,0.759-0.143,1.05-0.428L26.367,4.471c0.591-0.58,0.602-1.53,0.021-2.121s-1.528-0.602-2.121-0.021l-2.762,2.709   c-0.386-0.553-0.816-1.084-1.31-1.577c-4.614-4.613-12.121-4.613-16.734,0c-4.613,4.614-4.614,12.121,0,16.734   c4.108,4.107,10.505,4.547,15.116,1.34c0.098,0.459,0.318,0.896,0.676,1.253l6.717,6.717c0.979,0.979,2.561,0.979,3.537,0   C30.48,28.529,30.48,26.947,29.504,25.972z" />
    </g>
</svg>
`;

export const sync = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
`;

export const arrowDropdown = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M7 10l5 5 5-5z" />
    <path d="M0 0h24v24H0z" fill="none" /></svg>
`;

export const keyboardArrowUp = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
    <path d="M0 0h24v24H0z" fill="none" /></svg>
`;
export const keyboardArrowDown = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
    <path fill="none" d="M0 0h24v24H0V0z" /></svg>
`;

export const home = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    <path d="M0 0h24v24H0z" fill="none" />
</svg>
`;

export const deleteForever = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
    <path fill="none" d="M0 0h24v24H0z" />
</svg>
`;

export const addPhoto = html`
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
        <path id="a" d="M24 24H0V0h24v24z" />
    </defs>
    <clipPath id="b">
        <use xlink:href="#a" overflow="visible" />
    </clipPath>
    <path clip-path="url(#b)" d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z" />
</svg>
`;

export const arrowBack = html`
<svg width="24" height="24">
    <g id="arrow-back">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path>
    </g>
</svg>
`;

export const settings = html`
<svg width="24" height="24">
    <g id="settings">
        <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"></path>
    </g>
</svg>
`;

export const accountBox = html`
<svg width="24" height="24">
    <g id="account-box">
        <path d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"></path>
    </g>
</svg>
`;
export const assignment = html`
<svg width="24" height="24">
    <g id="assignment">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"></path>
    </g>
</svg>
`;
export const assignmentLate = html`
<svg width="24" height="24">
    <g id="assignment-late">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path>
    </g>
</svg>
`;
export const assignmentReturn = html`
<svg width="24" height="24">
    <g id="assignment-return">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"></path>
    </g>
</svg>
`;

export const assignmentReturned = html`
<svg width="24" height="24">
    <g id="assignment-returned">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"></path>
    </g>
</svg>
`;

export const assignmentTurnedIn = html`
<svg width="24" height="24">
    <g id="assignment-turned-in">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path>
    </g>
</svg>
`;

export const streetview = html`
<svg width="24" height="24">
    <g id="streetview">
        <path d="M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"></path>
        <circle cx="18" cy="6" r="5"></circle>
        <path d="M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"></path>
    </g>
</svg>
`;

export const linearScale = html`
<svg width="24" height="24">
    <g id="linear-scale">
        <path d="M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"></path>
    </g>
</svg>
`;

export const callMade = html`
<svg width="24" height="24">
    <g id="call-made">
        <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"></path>
    </g>
</svg>
`;

export const chevronLeft = html`<svg width="24" height="24">
    <g id="chevron-left">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </g>
</svg>
`;

export const chevronRight = html`<svg width="24" height="24">
    <g id="chevron-right">
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
    </g>
</svg>
`;

export const close = html`<svg width="24" height="24">
    <g id="close">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </g>
</svg>
`;

export const visibility = html`<svg width="24" height="24">
    <g id="visibility">
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path>
    </g>
</svg>
`;

export const insertChart = html`<svg width="24" height="24">
    <g id="insert-chart">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"></path>
    </g>
</svg>
`;

export const locationOn = html`<svg width="24" height="24">
    <g id="location-on">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path>
    </g>
</svg>
`;

export const accessTime = html`<svg width="24" height="24">
    <g id="access-time">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
    </g>
</svg>
`;

export const menu = html`<svg width="24" height="24">
    <g id="menu">
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
    </g>
</svg>
`;

export const image = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
</svg>
`;

export const signalWifiOff = html`<svg width="24" height="24">
    <g id="signal-wifi-off">
        <path d="M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"></path>
    </g>
</svg>
`;

export const signalWifi4Bar = html`<svg width="24" height="24">
    <g id="signal-wifi-4-bar">
        <path d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path>
    </g>
</svg>
`;

export const moreVert = html`<svg width="24" height="24">
    <g id="more-vert">
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
    </g>
</svg>
`;

export const create = html`<svg width="24" height="24">
    <g id="create">
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
    </g>
</svg>
`;

export const del = html`<svg width="24" height="24">
    <g id="delete">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
    </g>
</svg>
`;

export const touchApp = html`<svg width="24" height="24">
    <g id="touch-app">
        <path d="M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"></path>
    </g>
</svg>
`;

export const undo = html`<svg width="24" height="24">
    <g id="undo">
        <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"></path>
    </g>
</svg>
`;

export const redo = html`<svg width="24" height="24">
    <g id="redo">
        <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"></path>
    </g>
</svg>
`;

export const fileDownload = html`<svg width="24" height="24">
    <g id="file-download">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
    </g>
</svg>
`;

export const textFormat = html`<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24"
    height="24" viewBox="0 0 24 24">
    <defs>
        <path id="a" d="M24 24H0V0h24v24z" />
    </defs>
    <clipPath id="b">
        <use xlink:href="#a" overflow="visible" />
    </clipPath>
    <path clip-path="url(#b)" d="M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z" />
</svg>
`;

export const add = html`<svg width="24" height="24">
    <g id="add">
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
    </g>
</svg>
`;

export const linkedCamera = html`<svg width="24" height="24">
    <g id="linked-camera">
        <circle cx="12" cy="14" r="3.2"></circle>
        <path d="M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"></path>
        <path d="M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path>
    </g>
</svg>
`;

export const brush = html`<svg width="24" height="24">
    <g id="brush">
        <path d="M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"></path>
    </g>
</svg>
`;

export const rateReview = html`<svg width="24" height="24">
    <g id="rate-review">
        <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"></path>
    </g>
</svg>
`;

export const work = html`<svg width="24" height="24">
    <g id="work">
        <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"></path>
    </g>
</svg>
`;

export const locationSearching = html`<svg width="24" height="24">
    <g id="location-searching">
        <path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
    </g>
</svg>
`;

export const removeCircle = html`<svg width="24" height="24">
    <g id="remove-circle">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"></path>
    </g>
</svg>
`;

export const update = html`<svg width="24" height="24">
    <g id="update">
        <path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"></path>
    </g>
</svg>
`;

export const refresh = html`<svg width="24" height="24">
    <g id="refresh">
        <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path>
    </g>
</svg>
`;

export const lineWeight = html`<svg width="24" height="24">
    <g id="line-weight">
        <path d="M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"></path>
    </g>
</svg>
`;

export const done = html`<svg width="24" height="24">
    <g id="done">
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
    </g>
</svg>
`;

export const tagsLabels = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M9.17 15.5h5.64l1.14 3h2.09l-5.11-13h-1.86l-5.11 13h2.09l1.12-3zM12 7.98l2.07 5.52H9.93L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z" />
</svg>
`;

export const shapes = html`
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24" height="24" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
    <g>
        <path d="M59,10.894H33c-0.553,0-1,0.448-1,1v8.125L22.054,2.614c-0.178-0.312-0.492-0.543-0.868-0.504
		c-0.356,0-0.686,0.19-0.865,0.498L0.135,37.392c-0.179,0.31-0.18,0.691-0.001,1.001c0.178,0.31,0.509,0.501,0.866,0.501h16.292
		c-0.185,0.973-0.292,1.974-0.292,3c0,8.822,7.178,16,16,16s16-7.178,16-16c0-1.026-0.106-2.027-0.292-3H59c0.553,0,1-0.448,1-1v-26
		C60,11.342,59.552,10.894,59,10.894z M2.736,36.894L21.179,5.114L32,24.05v1.875c-0.128,0.008-0.254,0.028-0.382,0.039
		c-0.168,0.014-0.334,0.031-0.5,0.051c-0.324,0.039-0.645,0.089-0.963,0.147c-0.167,0.03-0.336,0.055-0.501,0.09
		c-0.417,0.09-0.828,0.196-1.234,0.318c-0.237,0.071-0.468,0.156-0.701,0.238c-0.19,0.067-0.38,0.134-0.568,0.208
		c-0.254,0.1-0.504,0.206-0.751,0.319c-0.148,0.068-0.293,0.14-0.439,0.212c-0.875,0.431-1.702,0.938-2.478,1.515
		c-0.114,0.085-0.229,0.168-0.341,0.255c-0.225,0.177-0.444,0.36-0.659,0.549c-0.121,0.106-0.239,0.215-0.357,0.325
		c-0.207,0.193-0.414,0.385-0.611,0.589c-0.092,0.095-0.178,0.197-0.268,0.294c-0.363,0.394-0.705,0.804-1.027,1.233
		c-0.099,0.132-0.201,0.261-0.297,0.396c-0.16,0.227-0.31,0.46-0.458,0.695c-0.089,0.142-0.176,0.285-0.261,0.43
		c-0.146,0.249-0.288,0.5-0.421,0.757c-0.057,0.111-0.108,0.226-0.163,0.338c-0.31,0.636-0.585,1.291-0.81,1.971H2.736z M33,55.894
		c-7.72,0-14-6.28-14-14c0-1.302,0.192-2.557,0.526-3.754c0.094-0.336,0.202-0.665,0.319-0.989c0.023-0.064,0.046-0.127,0.07-0.191
		c0.115-0.306,0.24-0.607,0.376-0.901c0.033-0.072,0.068-0.142,0.103-0.213c0.14-0.292,0.286-0.581,0.446-0.861
		c0.019-0.033,0.04-0.065,0.06-0.098c0.523-0.902,1.144-1.733,1.843-2.488c0.055-0.059,0.107-0.12,0.162-0.179
		c0.203-0.212,0.416-0.414,0.632-0.613c0.079-0.073,0.157-0.145,0.238-0.216c0.218-0.192,0.442-0.377,0.671-0.555
		c0.08-0.062,0.162-0.122,0.244-0.182c0.242-0.18,0.487-0.355,0.741-0.519c0.047-0.031,0.097-0.058,0.145-0.088
		c0.819-0.515,1.693-0.943,2.608-1.281c0.135-0.05,0.268-0.103,0.406-0.149c0.223-0.075,0.451-0.139,0.678-0.202
		c0.191-0.053,0.384-0.104,0.578-0.149c0.201-0.047,0.404-0.09,0.608-0.129c0.25-0.046,0.502-0.083,0.756-0.116
		c0.164-0.021,0.327-0.047,0.492-0.062c0.429-0.04,0.861-0.066,1.3-0.066s0.871,0.026,1.3,0.066
		c0.165,0.016,0.328,0.041,0.492,0.062c0.254,0.033,0.506,0.07,0.756,0.116c0.204,0.038,0.407,0.081,0.608,0.129
		c0.195,0.045,0.387,0.096,0.578,0.149c0.228,0.064,0.455,0.128,0.678,0.202c0.137,0.046,0.27,0.099,0.406,0.149
		c0.914,0.338,1.789,0.766,2.608,1.281c0.048,0.03,0.097,0.057,0.145,0.088c0.253,0.164,0.498,0.34,0.741,0.519
		c0.081,0.06,0.163,0.12,0.244,0.182c0.229,0.178,0.453,0.363,0.671,0.555c0.08,0.071,0.159,0.143,0.238,0.216
		c0.216,0.199,0.429,0.401,0.632,0.613c0.056,0.058,0.108,0.12,0.162,0.179c0.699,0.755,1.32,1.587,1.843,2.488
		c0.019,0.033,0.041,0.065,0.06,0.098c0.159,0.28,0.305,0.568,0.446,0.861c0.034,0.071,0.07,0.141,0.103,0.213
		c0.135,0.294,0.26,0.595,0.376,0.901c0.024,0.063,0.047,0.127,0.07,0.191c0.117,0.324,0.225,0.653,0.319,0.989
		C46.808,39.337,47,40.592,47,41.894C47,49.614,40.719,55.894,33,55.894z M52,36.894h-3.811c-0.225-0.68-0.5-1.336-0.81-1.972
		c-0.054-0.112-0.105-0.226-0.162-0.337c-0.133-0.257-0.275-0.508-0.421-0.757c-0.085-0.145-0.172-0.288-0.262-0.43
		c-0.148-0.235-0.298-0.468-0.457-0.694c-0.096-0.136-0.198-0.266-0.298-0.399c-0.322-0.428-0.663-0.838-1.025-1.231
		c-0.09-0.097-0.175-0.199-0.268-0.294c-0.197-0.203-0.403-0.396-0.611-0.589c-0.118-0.11-0.236-0.219-0.357-0.325
		c-0.215-0.189-0.434-0.372-0.659-0.549c-0.112-0.088-0.227-0.171-0.341-0.255c-0.776-0.577-1.604-1.084-2.479-1.515
		c-0.146-0.072-0.291-0.144-0.438-0.211c-0.247-0.113-0.497-0.219-0.751-0.319c-0.187-0.074-0.378-0.141-0.568-0.208
		c-0.108-0.038-0.212-0.082-0.321-0.118c-0.097-0.451-0.479-0.796-0.959-0.796c-0.295,0-0.554,0.133-0.737,0.337
		c-0.138-0.029-0.279-0.043-0.418-0.068c-0.319-0.058-0.639-0.109-0.963-0.147c-0.166-0.02-0.332-0.036-0.5-0.051
		c-0.128-0.011-0.253-0.031-0.382-0.039v-1.031c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1v-4c0.552,0,1-0.448,1-1
		c0-0.552-0.448-1-1-1v-4h24v4c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1v4c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1v4
		c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1v4c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1H52z" />
        <circle cx="40" cy="17.894" r="1" />
        <circle cx="37" cy="14.894" r="1" />
        <circle cx="40" cy="23.894" r="1" />
        <circle cx="52" cy="23.894" r="1" />
        <circle cx="37" cy="20.894" r="1" />
        <circle cx="43" cy="14.894" r="1" />
        <circle cx="46" cy="17.894" r="1" />
        <circle cx="52" cy="17.894" r="1" />
        <circle cx="49" cy="14.894" r="1" />
        <circle cx="43" cy="20.894" r="1" />
        <circle cx="46" cy="23.894" r="1" />
        <circle cx="49" cy="20.894" r="1" />
        <circle cx="55" cy="14.894" r="1" />
        <circle cx="55" cy="20.894" r="1" />
        <circle cx="52" cy="35.894" r="1" />
        <circle cx="43" cy="26.894" r="1" />
        <circle cx="46" cy="29.894" r="1" />
        <circle cx="52" cy="29.894" r="1" />
        <circle cx="49" cy="26.894" r="1" />
        <circle cx="49" cy="32.894" r="1" />
        <circle cx="55" cy="26.894" r="1" />
        <circle cx="55" cy="32.894" r="1" />
    </g>
</svg>
`;

export const arrowRight = html`
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#fff" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
        <path fill="none" d="M0 0h24v24H0V0z" />
    </svg>
`;

export const arrowLeft = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="#fff" d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
    <path fill="none" d="M0 0h24v24H0V0z" />
</svg>
`;

export const contentCopy = html`<svg width="24" height="24">
    <g id="content-copy">
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"></path>
    </g>
</svg>
`;


export const download = html`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
        viewBox="0 0 471.2 471.2" style="enable-background:new 0 0 471.2 471.2;" xml:space="preserve" width="24px" height="24px">
        <path d="M300.807,88.652l-94.235-77.447C198.809,4.817,185.218,0,174.958,0h-108.5C53.223,0,42.456,10.602,42.456,23.636  c0.002,3.121,0.168,312.155,0.168,313.775c0,11.805,8.258,20.05,20.082,20.05c7.5,0,229.139,0.115,229.139,0.115  c12.835,0,23.276-10.726,23.276-23.909V119.673C315.121,108.7,308.967,95.364,300.807,88.652z M66.444,1c0.005,0,0.009,0,0.014,0h0  C66.454,1,66.449,1,66.444,1z M239.589,235.915l-54.232,77.407c-1.551,2.213-3.88,3.482-6.391,3.482c-2.51,0-4.839-1.27-6.39-3.482  l-54.227-77.402c-1.684-2.402-1.978-5.09-0.787-7.378c1.191-2.289,3.653-3.542,6.587-3.542h31.971v-76.735  c0-4.963,4.078-9.265,9.041-9.265h27.622c4.963,0,9.337,4.302,9.337,9.265V225h31.668c2.933,0,5.395,1.251,6.586,3.539  C241.565,230.827,241.272,233.513,239.589,235.915z M206.009,113c-14.743,0-15.889-12.578-15.889-16.433V30.963L293.601,113H206.009  z"
            style="fill: rgb(255, 255, 255);"></path>
    </svg>
`;

export const upload = html`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
        viewBox="0 0 471.2 471.2" style="enable-background:new 0 0 471.2 471.2;" xml:space="preserve" width="24px" height="24px">
        <path d="M300.807,88.652l-94.111-77.447C198.805,4.712,185.562,0,175.206,0h-108.5C53.471,0,42.703,10.602,42.703,23.636  c0.002,3.121,0.167,312.155,0.167,313.775c0,11.805,8.258,20.05,20.082,20.05c7.5,0,228.892,0.115,228.892,0.115  c12.914,0,23.029-10.502,23.029-23.909V119.673C314.873,108.403,308.957,95.356,300.807,88.652z M175.206,1c0.003,0,0.007,0,0.01,0  C175.212,1,175.209,1,175.206,1L175.206,1z M240.622,229.454c-1.19,2.289-3.653,3.546-6.587,3.546h-32.162v76.729  c0,4.963-3.887,9.271-8.85,9.271h-27.622c-4.963,0-8.528-4.308-8.528-9.271V233h-32.477c-2.933,0-5.395-1.255-6.586-3.543  c-1.19-2.288-0.897-5.033,0.785-7.435l54.232-77.378c1.551-2.213,3.88-3.469,6.39-3.469c2.512,0,4.841,1.277,6.391,3.49  l54.227,77.349C241.519,224.417,241.813,227.166,240.622,229.454z M204.833,113.959c0.462,0.025,0.934,0.041,1.424,0.041h0  C205.769,114,205.294,113.986,204.833,113.959z M206.257,113c-15.924,0-16.384-14.751-16.384-16.433V30.96L293.844,113H206.257z"
            style="fill: rgb(255, 255, 255);"></path>
    </svg>
`;

export const error = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
</svg>
`;

export const description = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
</svg>`

export const activate = html`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.573 14.573" width="24" height="24">
    <g>
        <g>
            <path d="M7.286,14.573c-1.736,0-3.368-0.676-4.596-1.903c-1.227-1.228-1.904-2.86-1.904-4.597
                s0.677-3.369,1.904-4.597c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414c-0.85,0.851-1.318,1.981-1.318,3.183
                s0.468,2.333,1.318,3.183s1.979,1.317,3.182,1.317s2.332-0.468,3.182-1.317c0.851-0.85,1.318-1.98,1.318-3.183
                S11.318,5.74,10.469,4.89c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0c1.227,1.229,1.904,2.861,1.904,4.597
                s-0.677,3.369-1.904,4.597C10.655,13.897,9.023,14.573,7.286,14.573z" />
        </g>
        <g>
            <path d="M7.286,7c-0.553,0-1-0.448-1-1V1c0-0.552,0.447-1,1-1s1,0.448,1,1v5C8.286,6.552,7.84,7,7.286,7z" />
        </g>
    </g>
</svg>`

export const flashOff = html`
<svg width="24" height="24">
    <g id="flash-off"><path d="M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"></path></g>
</svg>`

export const flashOn = html`
<svg width="24" height="24">
    <g id="flash-on"><path d="M7 2v11h3v9l7-12h-4l4-8z"></path></g>
</svg>`

export const barcode = html`
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1280.000000pt" height="704.000000pt" viewBox="0 0 1280.000000 704.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,704.000000) scale(0.100000,-0.100000)" stroke="none">
<path d="M700 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M940 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M1170 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M1570 4010 l0 -2950 145 0 145 0 0 2950 0 2950 -145 0 -145 0 0
-2950z"/>
<path d="M1960 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M2120 4010 l0 -2950 110 0 110 0 0 2950 0 2950 -110 0 -110 0 0
-2950z"/>
<path d="M2440 4010 l0 -2950 105 0 105 0 0 2950 0 2950 -105 0 -105 0 0
-2950z"/>
<path d="M2750 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M3060 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M3300 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M3690 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M3930 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M4170 4010 l0 -2950 65 0 65 0 0 2950 0 2950 -65 0 -65 0 0 -2950z"/>
<path d="M4640 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M4880 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M5040 4010 l0 -2950 25 0 25 0 0 2950 0 2950 -25 0 -25 0 0 -2950z"/>
<path d="M5430 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M5660 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M5900 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M6060 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M6290 4010 l0 -2950 150 0 150 0 0 2950 0 2950 -150 0 -150 0 0
-2950z"/>
<path d="M6770 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M6930 4010 l0 -2950 65 0 65 0 0 2950 0 2950 -65 0 -65 0 0 -2950z"/>
<path d="M7240 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M7630 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M8020 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M8260 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M8500 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M8890 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M9130 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M9365 4010 l0 -2950 28 0 27 0 0 2950 0 2950 -27 0 -28 0 0 -2950z"/>
<path d="M9600 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M9760 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M10230 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M10390 4010 l0 -2950 145 0 145 0 0 2950 0 2950 -145 0 -145 0 0
-2950z"/>
<path d="M10780 4010 l0 -2950 110 0 110 0 0 2950 0 2950 -110 0 -110 0 0
-2950z"/>
<path d="M11100 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
<path d="M11490 4010 l0 -2950 110 0 110 0 0 2950 0 2950 -110 0 -110 0 0
-2950z"/>
<path d="M11800 4010 l0 -2950 30 0 30 0 0 2950 0 2950 -30 0 -30 0 0 -2950z"/>
<path d="M11960 4010 l0 -2950 70 0 70 0 0 2950 0 2950 -70 0 -70 0 0 -2950z"/>
</g>
</svg>
`;
